import {
  GET_CUSTOMER_CREDIT_CARD_SUCCESS,
  CUSTOMER_CREDIT_CARD_REQUESTING,
  LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
  RESET_CUSTOMER_CREDIT_CARD_ISFETCHING,
  DELETE_CUSTOMER_CREDIT_CARD_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_CREDIT_CARD_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case CUSTOMER_CREDIT_CARD_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CUSTOMER_CREDIT_CARDS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    case GET_CUSTOMER_CREDIT_CARD_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case DELETE_CUSTOMER_CREDIT_CARD_SUCCESS: {
      const data = { ...state.data };
      let query = [...state.query];
      delete data[action.payload.id];
      if (query.includes(action.payload.id)) {
        query = query.filter((id) => id !== action.payload.id);
      }
      return {
        ...state,
        data,
        query,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getDefaultCreditCard = (data) => {
  const customerCreditCardIds = Object.keys(data);
  const defaultCreditCardId = customerCreditCardIds.find(
    (id) => data[id].isDefault
  );
  if (defaultCreditCardId) {
    return data[defaultCreditCardId];
  }
  return null;
};
